import { Alert } from "antd";

import { AppButton } from "../../../shared/ui/button";

export const UserFormAlerts = ({ handleCancel, loadError }) => {
  return (
    <>
      {loadError && (
        <Alert
          type="error"
          showIcon
          message="No fue posible cargar esta vista"
          description={loadError}
          action={(
            <AppButton variant="secondary" onClick={handleCancel}>
              Volver
            </AppButton>
          )}
        />
      )}
    </>
  );
};
